export default __webpack_public_path__ + "static/media/wholesome-logo.50f28cc1.png";